import React from "react";
import { Navigate } from "react-router-dom";
import { useAccess } from "../contexts/AccessContext";
import { isAdminRole } from "../shared/utils";

const PrivatePage = ({ children, toolId = null, requireEdit = false }) => {
  const userId = Number(localStorage.getItem("user_id"));
  const { hasView, hasEdit, loading } = useAccess();

  // 1. Not logged in → go to login
  if (!userId) return <Navigate to="/" replace />;

  // 2. Admin → allow everything
  if (isAdminRole()) return <>{children}</>;

  // 3. Wait for permission loading
  if (loading) return null;

  // 4. Dynamic permission logic
  if (toolId != null) {
    const canView = hasView(toolId);
    const canEdit = hasEdit(toolId);

    // If route requires EDIT but user only has VIEW → redirect
    if (requireEdit && !canEdit) return <Navigate to="/home" replace />;

    // If user has no VIEW permission → redirect
    if (!requireEdit && !canView) return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default PrivatePage;
